import { _ as __assign } from '../../chunks/bundle-BsoKutlt.js';
import React__default from 'react';
import { useChannelContext } from '../context.js';
import { G as GroupChannelUIView } from '../../chunks/bundle-D9pTwrfW.js';
import { ChannelHeader } from './ChannelHeader.js';
import { MessageList } from './MessageList.js';
import { MessageInputWrapper } from './MessageInput.js';
import '../../chunks/bundle-DDQiHUtN.js';
import '../../useSendbirdStateContext.js';
import '../../withSendbird.js';
import '../../chunks/bundle-Cdxj4urY.js';
import '../../chunks/bundle-Qz21XT9v.js';
import '@sendbird/chat/message';
import '../../chunks/bundle-B_S6iTLS.js';
import '../../chunks/bundle-DqiG00CL.js';
import '../../chunks/bundle-K-ZPPQr-.js';
import '../../chunks/bundle-CtiWV1fp.js';
import '../../chunks/bundle-Dcu4oaT9.js';
import '../../chunks/bundle-SFTC4POJ.js';
import '../../chunks/bundle-JoxrNKuk.js';
import '../../chunks/bundle-BsRE6o7w.js';
import '../../chunks/bundle-ChbTBhrO.js';
import '@sendbird/chat/groupChannel';
import '../../utils/message/getOutgoingMessageState.js';
import '../../chunks/bundle-Bect-58W.js';
import '../../chunks/bundle-D8tzsrR-.js';
import '../../chunks/bundle-B-5tutOE.js';
import '../../chunks/bundle-B0uMDJtX.js';
import '../../chunks/bundle-BmAH27TX.js';
import '../../chunks/bundle-CKHpBJK8.js';
import '../../GroupChannel/components/TypingIndicator.js';
import '../../chunks/bundle-C8lF82nA.js';
import '../../chunks/bundle-D9fAlnnY.js';
import '../../chunks/bundle-BXx8qybA.js';
import '../../chunks/bundle-DoucA-x_.js';
import '../../ui/ConnectionStatus.js';
import '../../ui/Icon.js';
import '../../chunks/bundle-By8wnYCK.js';
import '../../ui/PlaceHolder.js';
import '../../ui/Loader.js';
import '../../chunks/bundle-Bcm0k_0e.js';
import '../../ui/IconButton.js';
import '../../ui/ChannelAvatar.js';
import '../../chunks/bundle-DFFEB3Ap.js';
import '../../ui/ImageRenderer.js';
import '../../chunks/bundle-Bpnh459j.js';
import '../../chunks/bundle-DPdxE_ue.js';
import '../../chunks/bundle-CMOgLqXn.js';
import '../../chunks/bundle-DleO6yp8.js';
import './Message.js';
import '../../chunks/bundle-DohVhehS.js';
import '../../chunks/bundle-CAw7uZEI.js';
import '../../Message/hooks/useDirtyGetMentions.js';
import '../../ui/DateSeparator.js';
import '../../chunks/bundle-CLhORKfu.js';
import '../../ui/MessageInput.js';
import '../../chunks/bundle-CkidI9AN.js';
import '../../ui/Button.js';
import '../../chunks/bundle-wZ2MFfjI.js';
import 'dompurify';
import '../../chunks/bundle-BmxObDcu.js';
import '../../chunks/bundle-rcslTaFE.js';
import '../../chunks/bundle-BrGYoMhP.js';
import '../../chunks/bundle-CuhsrQeV.js';
import '../../ui/MessageContent.js';
import '../../chunks/bundle-BImH5oF1.js';
import '../../chunks/bundle-BinOSDHU.js';
import '../../chunks/bundle-CzdgvCEO.js';
import '../../ui/MessageItemMenu.js';
import '../../ui/ContextMenu.js';
import 'react-dom';
import '@sendbird/chat';
import '@sendbird/chat/openChannel';
import '../../ui/SortByRow.js';
import '../../chunks/bundle-C0Yllxsy.js';
import '../../ui/MessageItemReactionMenu.js';
import '../../ui/ReactionButton.js';
import '../../chunks/bundle-ykyO1OLh.js';
import '../../ui/EmojiReactions.js';
import '../../ui/ReactionBadge.js';
import '../../ui/BottomSheet.js';
import '../../hooks/useModal.js';
import '../../chunks/bundle-CoaHGciJ.js';
import '../../ui/UserListItem.js';
import '../../ui/MutedAvatarOverlay.js';
import '../../ui/Checkbox.js';
import '../../ui/UserProfile.js';
import '../../sendbirdSelectors.js';
import '../../ui/Tooltip.js';
import '../../ui/TooltipWrapper.js';
import '../../Message/context.js';
import '../../ui/AdminMessage.js';
import '../../ui/QuoteMessage.js';
import '../../chunks/bundle-SmYaD8k7.js';
import '../../chunks/bundle-Db9p7p_C.js';
import '../../ui/ThreadReplies.js';
import '../../ui/OGMessageItemBody.js';
import '../../chunks/bundle-BWAbREcq.js';
import '../../ui/MentionLabel.js';
import '../../ui/LinkLabel.js';
import '../../ui/TextMessageItemBody.js';
import '../../ui/FileMessageItemBody.js';
import '../../ui/TextButton.js';
import '../../chunks/bundle-DJ03AWeL.js';
import '../../chunks/bundle-DuCVBYwc.js';
import '../../chunks/bundle-AEltqAUs.js';
import '@sendbird/uikit-tools';
import '../../ui/VoiceMessageItemBody.js';
import '../../ui/ProgressBar.js';
import '../../VoicePlayer/useVoicePlayer.js';
import '../../chunks/bundle-BnF3HgAG.js';
import '../../VoiceRecorder/context.js';
import '../../ui/PlaybackTime.js';
import '../../ui/ThumbnailMessageItemBody.js';
import '../../ui/UnknownMessageItemBody.js';
import '../../ui/TemplateMessageItemBody.js';
import '../../chunks/bundle-wW_bdEVL.js';
import '../../ui/FallbackTemplateMessageItemBody.tsx.js';
import '../../ui/LoadingTemplateMessageItemBody.tsx.js';
import '../../ui/FeedbackIconButton.js';
import '../../ui/MobileFeedbackMenu.js';
import '../../ui/MessageFeedbackModal.js';
import '../../ui/Input.js';
import '../../ui/MessageFeedbackFailedModal.js';
import '../../GroupChannel/components/SuggestedReplies.js';
import '../../chunks/bundle-D8_eHC2p.js';
import './FileViewer.js';
import '../../chunks/bundle-Brb15PE2.js';
import './RemoveMessageModal.js';
import '../../chunks/bundle-eanZccx-.js';
import '../../chunks/bundle-BvHiq6JB.js';
import '../../GroupChannel/components/UnreadCount.js';
import '../../GroupChannel/components/FrozenNotification.js';
import '../../chunks/bundle-R4_bJqEt.js';
import '../../chunks/bundle-CRP3quM7.js';
import '../../ui/TypingIndicatorBubble.js';
import '../../chunks/bundle-BElVRMmA.js';
import '../utils/getMessagePartsInfo.js';
import '../utils/compareMessagesForGrouping.js';
import '../../chunks/bundle-Lpom0rRJ.js';
import '../../GroupChannel/components/SuggestedMentionList.js';
import '../../ui/QuoteMessageInput.js';
import '../../VoiceRecorder/useVoiceRecorder.js';
import '../../chunks/bundle-DF417z4S.js';
import '../../chunks/bundle-CDD1VVKm.js';

var ChannelUI = function (props) {
    var context = useChannelContext();
    var channelUrl = context.channelUrl, isInvalid = context.isInvalid;
    // Inject components to presentation layer
    var _a = props.renderChannelHeader, renderChannelHeader = _a === void 0 ? function (p) { return React__default.createElement(ChannelHeader, __assign({}, p)); } : _a, _b = props.renderMessageList, renderMessageList = _b === void 0 ? function (p) { return React__default.createElement(MessageList, __assign({}, p, { className: "sendbird-conversation__message-list" })); } : _b, _c = props.renderMessageInput, renderMessageInput = _c === void 0 ? function () { return React__default.createElement(MessageInputWrapper, __assign({}, props)); } : _c;
    return (React__default.createElement(GroupChannelUIView, __assign({}, props, context, { isLoading: props === null || props === void 0 ? void 0 : props.isLoading, isInvalid: isInvalid, channelUrl: channelUrl, renderChannelHeader: renderChannelHeader, renderMessageList: renderMessageList, renderMessageInput: renderMessageInput })));
};

export { ChannelUI as default };
//# sourceMappingURL=ChannelUI.js.map
